import Module from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    modules: [],
    current: new Module(),
  },
  getters: {
    getCollection: state => state.modules,
    getById: state => (id) => state.modules.find(module => module.id === id),
    getCurrent: state => state.current,
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/module',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((module) => {
            commit('addModuleToCollection', { moduleData: module })
            return getters.getById(module.id)
          })

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/module',
        data: model.getJSON()
      }).then((res) => {

        commit('addModuleToCollection', { moduleData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/module/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addModuleToCollection', { moduleData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
  },
  mutations: {
    addModuleToCollection(state, { moduleData, opts }) {
      addToCollection(this, state.modules, moduleData, Module, opts)
    },
    removeModuleFromCollection(state, moduleId) {
      const index = state.modules.findIndex(el => el.id === moduleId)

      if (index === -1) {
        console.warn(`Could not find/delete module ${moduleId}`)
        return
      }

      state.modules.splice(index, 1)
    },
    clearCollection(state) {
      state.modules = []
    },
    updateCurrent (state, module) {
      state.current = module
    },
    resetCurrent (state) {
      state.current = new Module()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/module/store.js